import { app, emitter } from '../app.js';

class Alerts {
  public emitter;

  static install(Vue, options) {
    app.config.globalProperties.$alerts = new Alerts(emitter);
  }

  constructor(em) {
    this.emitter = em;
  }

  /**
   * Показать ошибку.
   * @param message
   */
  error(message: string) {
    this.emitter.emit('error', message);
  }

  /**
   * Показать информационное сообщение.
   * @param message
   */
  info(message: string) {
    this.emitter.emit('info', message);
  }

  /**
   * Если промис разрешится ошибкой, то показать ошибку.
   * @param promise
   */
  promiseError(promise: Promise<any>) {
    promise.catch((e) => {
      this.error(e.message);
    });
  }
}

export default Alerts;
